import classNames from 'classnames/bind';
import styles from './Form.module.scss';
import { createContext, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { FormStatus } from './FormStatus/FormStatus';

let cx = classNames.bind(styles);

export const FormContext = createContext(null);

export function Form({ className, children, emailSettings, formType, id, successMessage, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const formMethods = useForm({
		mode: 'onBlur',
	});

	const onSubmit = async (formData) => {
		if (formType === 'Email') {
      for (let i = 0; i < emailSettings.length; i++) {
				const cleanedEmail = replacEmailShortcodes(formData, emailSettings[i]);

				try {
					//Throw error if no recipient email provided
					if (!cleanedEmail.to) {
						const error = new Error('No recipient email provided.');
						error.name = 'configError';
						throw error;
					}

					//Send Email and get response
					const response = await fetch('/api/form/email', {
						method: 'POST',
						body: JSON.stringify({ email: cleanedEmail }),
					});
					const responseData = await response.json();

					//Throw Any Response Errors
					if (!response.ok) {
						const error = new Error(responseData['message']);
						error.name = 'serverError';
						error.status = response.status;
						throw error;
					}

				} catch (err) {
					console.error(err.message);
					formMethods.setError(`root.${err.name}`, {
						message: err.message,
						type: err.status,
					});
				}
			}
		}
	}

	if (!formType) {
		console.error('Set form type');
		return;
	}
	return (
		<FormProvider {...formMethods}>
			<form onSubmit={formMethods.handleSubmit(onSubmit)} className={cx(['ns_form', 'form', ...classNameArray])} {...props} noValidate aria-describedby={`${id}-help`} id={id}>
				{children}
				<FormStatus id={id} errors={formMethods.formState.errors} isError={formMethods.formState.errors?.root ? true : false} isSuccess={formMethods.formState.isSubmitSuccessful ? true : false} successMessage={successMessage} />
			</form>
		</FormProvider>
	);
}

function replacEmailShortcodes(formData, email) {
	let tempEmail = email;

	function replaceText(match, p1) {
		if (formData[p1]) {
			return Array.isArray(formData[p1]) ? formData[p1].join(', ') : formData[p1];
		} else {
			return '';
		}
	}

	for (const [key, value] of Object.entries(email)) {
		if (value === null) continue;
		tempEmail[key] = value.replace(/\[([^\]]+)\]/gi, replaceText);
	}
	return tempEmail;
}
